import React, { useEffect, useState } from "react";
import "../css/AddInvestigation.css";
import CommonTest from "./CommonTest";
import { toast } from "react-toastify";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useSecureUpdateItem } from "../../_helper/actions/mutation/items";
import { useLocation } from "react-router-dom";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import AdditionalTest from "../views/AdditionalTest";

const AddInvestigation = ({ closeModal, labTestData }) => {
  const [activeTab, setActiveTab] = useState("commonTests");
  const [searchTerm, setSearchTerm] = useState("");
  const [checkedItems, setCheckedItems] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [clinic] = useAtom(clinicAtom);

  const [formData, setFormData] = useState({});
  const [isFormValid, setIsFormValid] = useState(true);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const consultationId = queryParams.get("consultationId");

  const updateConsultationMutation = useSecureUpdateItem(
    ApiEndPoint.QP_CM_CONSULTATION_DATA,
    ApiEndPoint.QM_SC_SLOTS
  );

  // //(
  //   "lab_test_data",
  //   JSON.stringify(labTestData.lab_test_data, null, 2)
  // );

  useEffect(() => {
    if (labTestData?.lab_test_data) {
      setCheckedItems(labTestData?.lab_test_data);
      const initialFormData = labTestData?.lab_test_data.reduce((acc, item) => {
        acc[item.id] = { ...item };
        return acc;
      }, {});
      setFormData(initialFormData);
    }
  }, [labTestData]);

  const validateForm = () => {
    for (let item of checkedItems) {
      const fields = formData[item.id] || {};
      if (!fields.value || !fields.note) {
        setIsFormValid(false);
        return false;
      }
    }
    setIsFormValid(true);
    return true;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (checkedItems.length === 0) {
      return;
    }
    if (!validateForm()) {
      toast.error("Please fill in all required fields.");
      return;
    }

    const payload = {
      id: Number(consultationId),
      action: "patchConsultationData",
      clinic_id: clinic?.id,
      frontend: "True",
      lab_test_data: checkedItems.map((item) => ({
        id: item.id,
        test_name: item.name,
        value: formData[item.id]?.value,
        reference:
          formData[item.id]?.reference ||
          `${item.lab_test_threshold.min_threshold} - ${item.lab_test_threshold.max_threshold}`,
        unit: formData[item.id]?.unit || item.ufm.name,
        date: formData[item.id]?.date || new Date().toISOString().split("T")[0],
        note: formData[item.id]?.note,
        description: formData[item.id]?.description,
      })),
    };

    updateConsultationMutation.mutate(
      { id: null, data: payload },
      {
        onSuccess: () => {
          toast.success("Successfully updated");
          closeModal();
          setCheckedItems([]);
          setSearchTerm("");
          setSelectedCategory("");
          setFormData({});
        },
        onError: () => {
          toast.error("Error");
        },
      }
    );
  };

  return (
    <div className="main-cont">
      <div className="tabs">
        <p
          className={`${activeTab === "commonTests" ? "active" : ""}`}
          onClick={() => setActiveTab("commonTests")}
        >
          Common Tests
        </p>
        <p
          className={`${activeTab === "additionalTests" ? "active" : ""}`}
          onClick={() => setActiveTab("additionalTests")}
        >
          Additional Tests
        </p>
      </div>
      <hr></hr>

      {activeTab === "commonTests" && (
        <CommonTest
          closeModal={closeModal}
          formData={formData}
          setIsDropdownOpen={setIsDropdownOpen}
          setCheckedItems={setCheckedItems}
          setFormData={setFormData}
          selectedCategory={selectedCategory}
          setSearchTerm={setSearchTerm}
          searchTerm={searchTerm}
          handleSubmit={handleSubmit}
          checkedItems={checkedItems}
          isDropdownOpen={isDropdownOpen}
          setSelectedCategory={setSelectedCategory}
          updateConsultationMutation={updateConsultationMutation}
        />
      )}

      {activeTab === "additionalTests" && <AdditionalTest />}
    </div>
  );
};

export default AddInvestigation;
